var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.048 6.81C7.093 7.924 5.81 10.065 5.81 12.476a6.48 6.48 0 003.997 5.983 6.473 6.473 0 008.461-8.461A6.473 6.473 0 0012.286 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.048 10.857V6.81H5"
  })));
}
export default SvgRefreshIcon;